<template>
  <div class="user-account-layout" :class="{ desktop: $isDesktop }">
    <slot />
    <div id="teleport-target"></div>
  </div>
  <footer class="user-account-layout-footer">
    <version />
  </footer>
</template>

<script lang="ts">
import { Component, Vue, toNative } from '~/utility/pu-class-decorator'

@Component({
  setup() {
    const searchWizardStore = useSearchWizardStore()
    const authStore = useAuthStore()
    return {
      authStore,
      searchWizardStore,
    }
  },
})
class UserAccountLayout extends Vue {}

export default toNative(UserAccountLayout)
</script>

<style scoped>
.user-account-layout-footer .version {
  font-size: 0.75rem;
}
</style>

<style>
@import url('~/assets/css/user-account.css');
</style>
